import sendRequest from '../client/sendRequest';

const BASE_URL = '/api/services';

// Get all Services
export async function getServices() {
  return await sendRequest(BASE_URL, 'GET');
}

// Create a Service
export async function postService(data) {
  return await sendRequest(BASE_URL, 'POST', data);
}

//Edit a Service
export async function editService(id, data) {
  return await sendRequest(`${BASE_URL}/${id}`, 'PUT', data);
}

//Delete a Service
export async function deleteService(id) {
  return await sendRequest(`${BASE_URL}/${id}`, 'DELETE');
}
